import React from "react";
import { View } from "react-native";
import { EStyleSheet, useDynamicStyles } from "react-native-extended-stylesheet-typescript";

export const Loading: React.FC = () => {
    const styles = useDynamicStyles(calculateStyles);

    return (
        <View style={styles.LoadingContainer}>
            <svg className="loading-animation" height="48px" viewBox="0 0 24 24" width="48px" fill="#ffffff">
                <path
                    d="M17.6,6.3C16.2,4.9,14.2,4,12,4c-4.4,0-8,3.6-8,8s3.6,8,8,8c3.7,0,6.8-2.5,7.7-6h-2.1c-0.8,2.3-3,4-5.6,4c-3.3,0-6-2.7-6-6
                    s2.7-6,6-6c1.7,0,3.1,0.7,4.2,1.8L17.6,6.3z"
                />
            </svg>
        </View>
    );
};

const calculateStyles = () => {
    return EStyleSheet.create({
        LoadingContainer: {
            alignSelf: "stretch",
            position: "absolute",
            zIndex: 10000,
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            flex: 1,
            backgroundColor: "rgba(4, 42, 81, 0.9)",
            alignItems: "center",
            justifyContent: "center",
        },
    });
};
